import Component from '@glimmer/component'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import { on } from '@ember/modifier'
import {
  getCellValue,
  getCellFormatConfig,
  type CustomCellSignature,
} from 'teacher-ui-client/components/stable-table/basic-table/cell'
import { optional } from 'teacher-ui-client/helpers/optional'

export default class ClickableCell extends Component<CustomCellSignature> {
  get value() {
    return getCellValue(this.args.tableMeta)
  }

  get formatEmptyConfig() {
    return getCellFormatConfig(this.args.tableMeta)
  }

  get formattedValue() {
    return formatValue(this.value, this.formatEmptyConfig)
  }

  <template>
    <span data-test-cell-clickable {{on "click" (optional @tableMeta.cellObject.onClick)}} role="button" ...attributes>
      {{this.formattedValue}}
    </span>
  </template>
}
